import { Module } from 'wrapper6'

const $ = jQuery

export default class SmoothScroll extends Module {
  ready () {
    $('a[href^="#"]').click((e) => {
      e.preventDefault()

      const id = this.getIdFromHref(e.target)
      const el = document.getElementById(id)

      if (el) {
        $('html, body').animate({
          scrollTop: $(`#${id}`).offset().top - 150
        }, 500)

        this.openAccordion(el)
      }
    })
  }

  openAccordion (el) {
    //  Open accordion on single product page
    if (el.classList.contains('accordion-item')) {
      const trigger = el.querySelector('.accordion-trigger')
      trigger.click()
    }
  }

  getIdFromHref (href) {
    let id = null

    if (href) {
      id = $(href).attr('href')
      id = id.replace('#', '')
    }

    return id
  }
}
